// src/i18n/es/dispensers.ts
// «Dispensadores» — route /dispensers, Dirección. The production dashboard's
// dispenser block as its own screen.
export const dispensers = {
  name: 'Dispensadores |||| Dispensadores',
  subtitle: 'Entrega de llaves en los dispensadores de sus instalaciones',

  tiles: {
    keysDelivered: 'Llaves entregadas',
    keysDeliveredDetail: 'En el periodo',
    successRate: 'Entregas correctas',
    successRateDetail: '%{delivered} de %{attempts} intentos acabaron con la llave entregada',
    noAttempts: 'Sin intentos de entrega en el periodo',
    activeDispensers: 'Dispensadores activos',
    activeDispensersDetail: 'Con algún evento en el periodo, de los registrados y no dados de baja',
    failed: 'Entregas fallidas',
    failedDetail: 'Intentos que no acabaron con la llave entregada, por cualquier causa',
  },

  byDay: {
    title: 'Llaves entregadas y entregas fallidas por día',
    series: { keysDispensed: 'Llaves entregadas', errors: 'Entregas fallidas' },
  },

  byHotel: {
    title: 'Por instalación',
    description: 'Todas las instalaciones con algún intento de entrega en el periodo, de más a menos llaves entregadas.',
    empty: 'Sin intentos de entrega en el periodo.',
    columns: {
      hotel: 'Instalación',
      keysDispensed: 'Entregadas',
      errors: 'Entregas fallidas',
      successRate: '% correctas',
      dispenserCount: 'Dispensadores registrados',
    },
  },

  errorTypes: {
    title: 'Errores por tipo',
    description: 'Cada error del periodo y en cuántas entregas fallidas estuvo; un intento con dos causas cuenta en las dos.',
    empty: 'Sin errores en el periodo.',
    columns: {
      type: 'Tipo',
      count: 'Errores',
      failed: 'Entregas fallidas',
    },
  },

  noDispensers: {
    title: 'No hay dispensadores en las instalaciones seleccionadas',
    description: 'Elija otras instalaciones o consulte la entrega de llaves en Canales.',
  },

  errorCodes: {
    NO_CODE: 'Sin código de error',
    MECH_JAM: 'Atasco mecánico',
    OUT_OF_KEYS: 'Sin tarjetas',
    SENSOR_ERROR: 'Error de sensor',
    TIMEOUT: 'Tiempo agotado',
    DOOR_OPEN: 'Puerta abierta',
    QR_READ_ERROR: 'Error de lectura del QR',
    QR_SIGNATURE: 'Firma del QR no válida',
    QR_IS_EXPIRED: 'QR caducado',
    QR_FORMAT: 'Formato del QR no válido',
    CARD_TIMEOUT_RW_POSITION: 'Tiempo agotado en la posición de lectura',
    CARD_TIMEOUT_BEZEL: 'Tiempo agotado en la salida de la tarjeta',
    CARD_HOPPER_EMPTY: 'Depósito de tarjetas vacío',
    CARD_HOPPER_LOW: 'Quedan pocas tarjetas',
    CARD_FEEDED_FROM_FRONT: 'Tarjeta introducida por el frontal',
    CARD_NOT_PICKED_UP: 'Tarjeta no recogida',
    CARD_WRITE_FAILED: 'Error al grabar la tarjeta',
    CARD_READ_FAILED: 'Error al leer la tarjeta',
    MAX_CARDS_REACHED: 'Máximo de tarjetas alcanzado',
    RFID_ENCODER_NOT_FOUND: 'Codificador de tarjetas no encontrado',
    KD_REBOOT: 'Dispensador reiniciado',
    KD_UID_NOT_REGISTERED: 'Tarjeta no registrada',
    KD_DIGITAL_KEY_DELIVERY_FAILED: 'No se pudo entregar la llave digital',
    LOCKS_GENERAL: 'Error del sistema de cerraduras',
    LOCKS_TIMEOUT: 'Tiempo agotado en el sistema de cerraduras',
    LOCKS_ENCODER_COMM: 'Error de comunicación con el codificador',
    LOCKS_COMM: 'Error de comunicación con el sistema de cerraduras',
    LOCKS_SYNTAX: 'Petición no válida al sistema de cerraduras',
    LOCKS_NO_FILES: 'Faltan los archivos del sistema de cerraduras',
    LOCKS_OVERFLOW: 'Sistema de cerraduras desbordado',
    LOCKS_CARD: 'Error de tarjeta de cerradura',
    LOCKS_FORMAT: 'Formato no válido en el sistema de cerraduras',
    LOCKS_UNKNOWN_ROOM: 'Habitación no configurada en el sistema de cerraduras',
    LOCKS_CHECKED_OUT: 'La estancia ya ha salido',
    LOCKS_OUT_OF_SERVICE: 'Sistema de cerraduras fuera de servicio',
    LOCKS_BUSY: 'Sistema de cerraduras ocupado',
    LOCKS_VALID_STAFF_CARD: 'Tarjeta de personal detectada',
    LOCKS_CARD_READ_FAILED: 'Error al leer la tarjeta de cerradura',
    LOCKS_CARD_WRITE_FAILED: 'Error al grabar la tarjeta de cerradura',
    LOCKS_READ_ERROR: 'Error de lectura en el sistema de cerraduras',
    NETWORK_TIMEOUT: 'La red no respondió a tiempo',
    NETWORK_DISCONNECTED: 'Red desconectada',
    SYSTEM_ERROR: 'Error interno del dispositivo',
    PMS_RESERVATION_NOT_FOUND: 'Reserva no encontrada en el sistema del hotel',
    PMS_COMM: 'Error de comunicación con el sistema del hotel',
    PMS_RECOVERY_FAILED: 'No se pudo recuperar el check-in en el sistema del hotel',
  },

  help: {
    title: 'Dispensadores',
    description: 'Cuántas llaves han entregado los dispensadores de sus instalaciones, cuántas entregas han fallado y qué dispensadores han estado activos en el periodo.',
    features: {
      success: 'Un intento es un huésped en un dispensador: los eventos de la misma reserva (o habitación) en el mismo dispensador con menos de 10 minutos entre uno y otro. Es correcto si sale alguna llave y fallido en otro caso, sea cual sea la causa. El porcentaje es intentos correctos entre intentos.',
      active: 'Un dispensador está activo si ha enviado cualquier señal en el periodo, aunque no haya entregado ninguna llave. Los dispensadores dados de baja no cuentan. Los días son los del hotel.',
    },
    tips: {
      errors: 'La tabla de errores incluye también los que no impidieron la entrega (el huésped lo volvió a intentar y obtuvo la llave), por eso cuenta más errores que entregas fallidas.',
    },
  },
};

export default dispensers;
